module.exports = __webpack_public_path__ + "static/media/zoom-2-copy.6da34929.svg";